/**
 * Process Block
 *
 * UI for handling the logic and animations of process block
 */

const $ = require( 'jquery' );

var itblProcess = function(el){

  //setup some variables
  this.$el      = $(el);
  this.$steps      = this.$el.find('.js-itbl-process__steps');
  this.$step      = this.$el.find('.js-itbl-process__step');
  this.$next      = this.$el.find('.js-itbl-process__next');
  this.$content       = this.$el.find( '.itbl-process__content' );
  this.stepTargets    = this.$step.map((i, el) =>  el.getAttribute('data-step') ).get();

  //get the active step on initial load or set to 0
  this.activeIndex    = this.$steps.attr('data-active-step') || 0;
  this.activeEl     = this.$el.find( `[data-target=${this.activeIndex}]` );
  this.stepsOnly      = this.$el.hasClass('js-itbl-process--steps-only');

  this.init();
};

itblProcess.prototype.init = function(){

  this.events();

};

itblProcess.prototype.events = function(){

  if( !(this.stepsOnly) ){
    this.$step.on('click', this.event__handleSelectStep.bind(this));

  }

  this.$next.on('click', this.event__handleNextStep.bind(this));

// catch on document...
  document.addEventListener("itblProcess.goToStep", (event)=>{ // (1)

    const { target } = event.detail;

    if( this.stepTargets.includes( target.toString() ) ){

      this.event__handleTrigger( target );

    }

  });

};

itblProcess.prototype.event__handleSelectStep = function(event){
  event.preventDefault();
  const $target = $(event.currentTarget);
  //get the step index
  const selectedIndex = event.currentTarget.getAttribute('data-target');

  //if this is the same node, the cancel funtion
  if( event.currentTarget.isSameNode( this.activeEl[0] ) ){
    return;
  }

  if(  !$target.hasClass('disabled-step') ) {

    this.helper__handleActiveCircle( $target )

  }

  if( selectedIndex ){

    this.activeIndex = selectedIndex;
    this.helper__handleAnimation( this.activeIndex );

  }
};

itblProcess.prototype.helper__handleActiveCircle = function($target){

  this.activeEl = $target;
  this.$steps[0].setAttribute('data-active-step', this.$step.index( $target ) );

  $('.itbl-process__steps.active-step').removeClass('active-step');
  this.activeEl.addClass('active-step');
};


itblProcess.prototype.event__handleNextStep = function(event){
  event.preventDefault();
  
  let activeStep = parseInt(this.$steps.attr('data-active-step'));

  this.helper__handleAnimation(activeStep+1);

};

itblProcess.prototype.event__handleTrigger = function( target ){

  if( typeof target !== 'undefined' ){

    const $targetCircle = $( this.$step.filter(`[data-step="${target}"]`) );

    this.helper__handleActiveCircle( $targetCircle );


  }

};

itblProcess.prototype.helper__handleAnimation = function(id) {

  const $targetContent = $( this.$content.filter(`[data-target-content="${id}"]`) );

  $('.itbl-process__content.active-step').hide(400, () => { $('.itbl-process__content.active-step').removeClass('active-step'); });
  $targetContent.show(400, () => { $targetContent.addClass('active-step'); });
}

$(document).ready(function(){
  $('.js-itbl-process').each(function(){
    new itblProcess(this);
  });
});
